var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
import { propsCallback } from "./blueprint";
import combine from "./combine";
export function isolate() {
    var composables = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        composables[_i] = arguments[_i];
    }
    var begin = {
        instanceCallbacks: [
            propsCallback(function (props) {
                return __assign({}, props, { __isolation: props.__isolation
                        ? props.__isolation.concat([props]) : [props] });
            }),
        ],
    };
    var end = {
        instanceCallbacks: [
            propsCallback(function (props) { return props.__isolation[props.__isolation.length - 1]; }),
        ],
    };
    return combine.apply(void 0, [begin].concat(composables, [end]));
}
export default isolate;

//# sourceMappingURL=isolate.js.map



//////////////////
// WEBPACK FOOTER
// ./~/reassemble/lib/isolate.js
// module id = 49
// module chunks = 0